import { useMutation } from "@tanstack/react-query";
import { api } from "../context";
import { PrescriptionDetail, RequestDetail } from "../interfaces";

interface AddPrescriptionDetailProps {
  requestId: string;
  prescriptionDetail: PrescriptionDetail;
}

export const useAddPrescriptionDetail = () => {
  return useMutation({
    mutationFn: async ({
      requestId,
      prescriptionDetail,
    }: AddPrescriptionDetailProps): Promise<RequestDetail> => {
      const response = await api<RequestDetail>({
        method: "post",
        url: `/requests/${requestId}/detail`,
        data: JSON.stringify(prescriptionDetail),
      });
      return response;
    },
  });
};
